module.exports = __webpack_public_path__ + "static/media/halong-bay-vietnam.885ccc75.jpg";